module.exports = __webpack_public_path__ + "img/toul-kork-branch.1eb05247.jpg";